import React from "react";
import Home from "./Home";
import { Row, Col } from "react-materialize";
import { Link, Redirect } from "react-router-dom"
import { CheckAuth, BASE_URL } from "../../Util";
import { trans } from "../../Lang";

// import jsonData from '../../../assets/user_home.json'; // dummy JSON

const course = ({data}) => {
	console.log("CATEGORY:", data.category.name)

	return(
		<div>
			<Col className="course-border bg-white" m={3} s={12}>
				<Link to={`/courses/${data.slug}`}>
					<div>
						<img src={data.thumbnail} alt="blog_picture"/>
						<div className="pl-sm">
							<h3 className="course-role">{data.title}</h3>
							<br/>
							<p className="course-title">{data.category.name}</p>
							{data.time && 
								<p className="course-time">{data.time}</p>
							}
							{data.instructor != "" && 
								<p className="course-tutor">{data.instructor}</p>
							}
						</div>
					</div>
				</Link>
			</Col>
		</div>
	)
}

const Components = data => {
	return React.createElement(course, {
		data: data,
		key: data.uuid,
	})
}

class UserHome extends Home {
	constructor(props) {
		super(props);
	}

	render() {
		let isLogin = CheckAuth() != "";
		if (!isLogin) {
			return <Redirect to={"/login?redirect=/home"} />
		}

		let jsonData = {
			courses : [],
			events : []
		}
		let dataIsEmpty

		this.state.sections.map(data => {
			if(data.title == "Kuliah Terbaru") {
				jsonData.courses = data.items
			}
			if(data.title == "Event Terkini") {
				jsonData.events = data.items

				jsonData.events.map(data => {
					// console.log("TIME: ", data)
					data.time = data.held_at_formatted.split("pukul")[0]
				})
			}
		})

		console.log("jsonData::::", jsonData)
		console.log("HOME DATA in UserHome: \n", this.state.sections)

		jsonData.events.length == 0 && jsonData.courses.length == 0? dataIsEmpty = true : false
		
		// let takenCourseExist = false
		// let takenCourses = []

		// jsonData.courses.map(data => {
		// 	if(data.taken == true) takenCourses.push(data)
		// })

		// if(takenCourses.length != 0) takenCourseExist = true

		

		
		return (
			<div>
				{isLogin && (
					<div>
						{!dataIsEmpty && (
							<div>
								{jsonData.courses.length != 0 && (
									<div>
										<div className="bg-yellow">
											<Row className="pad-s container">
												<h2 className="course-header">Pilih Kursus Sesuai Role Kamu</h2>
												{jsonData.courses.map(data => Components(data))}
											</Row>
										</div>
									</div>
								)}
								{jsonData.events.length != 0 && (
									<div>
										<Row className="pad-s container">
											<h2 className="course-header">Event Terbaru</h2>
											{jsonData.events.map(data => Components(data))}
										</Row>
									</div>
								)}
							</div>
						)}
						{dataIsEmpty && (
							<div className="container">
								<p className="no-content center">Mohon maaf, belum ada pelatihan & event yang dapat kamu ikuti saat ini ☹</p>
							</div>
						)}
					</div>
				)}
				{!isLogin && (
					<div>
						{this.props.history.push(`/login`)}
					</div>
				)}

			</div>
		);
	}
}

export default UserHome;



// WEBPACK FOOTER //
// ./src/components/Public/Home/UserHome.js